import data from "../../.sourceflow/practice_area.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const practice_area_helper = new CollectionHelper(data);
